module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-09-044db5625051ce5907ac2001dda05b03.jpg";